/* Handlers for e3ds are called based on the "cmd" field
* Inside the handler checks the 'type' field to see if its {request, response, or notif}
* Each command may have an optional payload that is a json object in the 'msg' field
* To summarize an properly formatted incoming message is of the form

{cmd: <command>, type: <request|response|notif>, msg: {optional custom json obj}   }
*/

window.e3ds.onEvent('connect', (data) => {
    //look for incoming requests
    if (data.type === 'response') {
        window.xrconnectedState = true;
        console.log(`Game replies its state is ${data.msg.status}`);
    } else {
        console.log('===  Response Value is: ', data);
    }
});

window.e3ds.onEvent('openBrowserTabTo', (data) => {
    //don't check it, just call
    window.open(data.msg, '_blank');
});
